// Saved reports are listed A–Z by title, ignoring case, in both the reporting
// nav and the report builder sidebar.
export function sortSavedReportsByTitle<T extends { title: string }>(
  reports: readonly T[],
): T[] {
  return [...reports].sort((a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: "base" }),
  );
}
